module.exports = __webpack_public_path__ + "assets/img/crk.df976ca8.png";